
























































































































import { mapGetters } from 'vuex';
import { DataTableHeader } from 'vuetify';
import { textOverflowMiddle, truncateString } from '@/helpers/formatString';

const CopyAddress = (): Promise<any> =>
  import('@/components/CopyAddress.vue');
const VStatus = (): Promise<any> => import('@/components/VStatus.vue');
const ConfirmationDialog = (): Promise<any> =>
  import('@/components/ConfirmationDialog.vue');
const CopyStakeBroadcastSettingsDialog = (): Promise<any> =>
  import(
    '@/views/CopyStake/CopyStakeStreamer/CopyStakeStreamerBroadcastSettingsDialog.vue'
  );
const CopyStakeCreateEditStreamerDialog = (): Promise<any> =>
  import(
    '@/views/CopyStake/CopyStakeStreamer/CopyStakeStreamerEditDialog.vue'
  );
const CopyStakeStreamerThumbnailsDialog = (): Promise<any> =>
  import(
    '@/views/CopyStake/CopyStakeStreamer/CopyStakeStreamerThumbnailsDialog.vue'
  );

import {
  deleteStreamer,
  getStreamersList,
  updateStreamer
} from '@/api/CopyStake/Streamers';
import { startStreamerBroadcast } from '@/api/CopyStake/StreamerBrodcast';
import {
  TStreamer,
  EStreamerStatus,
  EStreamerType,
  EStreamingType
} from '@/api/schema';

import { getLangLabel } from '@/helpers/langHelpers';
import { addThumbnailPrefix } from '@/helpers/copyStakeHelpers';
import { errorToastMessage } from '@/helpers/errorToastMessage';
import { objectToBlob } from '@/helpers/blobHelper';
import CopyStakeStreamersStats from '@/views/CopyStake/CopyStakeStreamer/CopyStakeStreamersStats.vue';

const DEFAULT_PAGINATION_OPTIONS = {
  page: 1,
  itemsPerPage: 10
};
const STREAMER_TYPE_MAP = {
  [EStreamerType.PRIVATE]: {
    label: 'Private',
    type: 'system-success'
  },
  [EStreamerType.PUBLIC]: {
    label: 'Public',
    type: 'additional-finished'
  }
};
const STREAMING_TYPE_MAP = {
  [EStreamingType.WHIP]: {
    label: 'WHIP',
    type: 'additional-progress'
  },
  [EStreamingType.WEB]: {
    label: 'WEB',
    type: 'additional-new'
  }
};

export default {
  name: 'CopyStakeStreamersTable',
  components: {
    CopyStakeStreamersStats,
    CopyStakeBroadcastSettingsDialog,
    CopyStakeCreateEditStreamerDialog,
    CopyStakeStreamerThumbnailsDialog,
    ConfirmationDialog,
    CopyAddress,
    VStatus
  },
  data(): any {
    return {
      EStreamingType,
      EStreamerStatus,
      STREAMER_TYPE_MAP,
      STREAMING_TYPE_MAP,
      isLoading: false,
      streamersList: [],
      total: null,
      tableOptions: { ...DEFAULT_PAGINATION_OPTIONS },
      dialogs: {
        streamerCreateEdit: false,
        streamerThumbnails: false,
        confirm: false,
        broadcastSettings: false,
        loading: false,
        data: undefined
      }
    };
  },
  computed: {
    ...mapGetters('Onboarding', ['operatorId']),
    canEdit(): boolean {
      return this.$role.can.update('copy_stake streamers');
    },
    headers(): DataTableHeader[] {
      const output: DataTableHeader[] = [
        { text: 'Date Added', value: 'createdAt' },
        { text: 'Wallet Address', value: 'playerWalletHash' },
        { text: 'Operator User ID', value: 'operatorUserId' },
        { text: 'Nickname', value: 'nickname' },
        { text: 'Channel ID', value: 'channelId' },
        { text: 'Language', value: 'language' },
        { text: 'Type', value: 'type' },
        { text: 'Thumbnails', value: 'images' }
      ];

      if (this.canEdit) {
        output.splice(5, 0, { text: 'Manage Broadcast', value: 'active' });

        output.push({
          text: 'Action',
          value: 'actions',
          width: 196,
          align: 'center'
        });
      }

      return output;
    }
  },
  watch: {
    operatorId: {
      handler: 'fetchStreamersData',
      immediate: true
    }
  },
  methods: {
    getLangLabel,
    addThumbnailPrefix,
    textOverflowMiddle,
    truncateString,
    checkIsOnline(status: EStreamerStatus): boolean {
      return [EStreamerStatus.ONLINE, EStreamerStatus.BROADCAST].includes(
        status
      );
    },
    showDeleteDialog(streamer: TStreamer): void {
      this.dialogs.confirm = true;
      this.dialogs.data = {
        disclaimer: `
          <p>
            Are you sure you want to delete streamer with nickname <strong>${
              streamer.nickname || streamer.playerId
            }</strong>?
          </p>
          <p class="text--disabled">You will not be able to recover it.</p>`,
        icon: 'mdi-alert-octagon',
        header: 'Delete Streamer',
        okText: 'Delete',
        handler: () => this.handlerOnDeleteStreamer(streamer)
      };
    },
    showStartStreamDialog(streamer: TStreamer): void {
      this.dialogs.confirm = true;
      this.dialogs.data = {
        disclaimer:
          'Are you sure you want to start stream for this streamer?',
        header: 'Start stream',
        okText: 'Start stream',
        okButtonType: 'success',
        handler: () => this.handlerOnStartStream(streamer)
      };
    },
    showBroadcastSettingsDialog(streamer: TStreamer): void {
      this.dialogs.broadcastSettings = true;
      this.dialogs.data = streamer;
    },
    showStreamerThumbnailsDialog(streamer: TStreamer): void {
      this.dialogs.streamerThumbnails = true;
      this.dialogs.data = streamer;
    },
    showChangeStreamerBroadcastStatusDialog(streamer: TStreamer): void {
      const disclaimer = streamer.active
        ? `Are you sure you want to stop broadcasting for <strong>${
            streamer.nickname || streamer.playerId
          }</strong>?`
        : `Are you sure you want to start broadcasting for <strong>${
            streamer.nickname || streamer.playerId
          }</strong>?`;
      const header = streamer.active
        ? 'Stop Broadcasting'
        : 'Start Broadcasting';
      const okText = streamer.active ? 'Stop' : 'Start';
      const okButtonType = streamer.active ? 'primary' : 'error';

      this.dialogs.confirm = true;
      this.dialogs.data = {
        disclaimer,
        header,
        okText,
        okButtonType,
        handler: () => this.handlerOnStreamerBroadcastStatusChange(streamer)
      };
    },
    async handlerOnDeleteStreamer(streamer: TStreamer): Promise<void> {
      try {
        this.dialogs.loading = true;

        await deleteStreamer(streamer.id);
        this.fetchStreamersData();
        this.$toast.success(
          `Streamer "${streamer.nickname}" was successfully deleted`
        );
        this.closeDialog('confirm');
      } catch (error) {
        errorToastMessage(error);
      } finally {
        this.dialogs.loading = false;
      }
    },
    handlerOnCreateEditStreamer(streamer?: TStreamer): void {
      if (streamer) {
        this.dialogs.data = streamer;
      }

      this.dialogs.streamerCreateEdit = true;
    },
    closeDialog(type: string, resetData: boolean = true): void {
      this.dialogs[type] = false;

      if (resetData) {
        this.$nextTick(() => {
          this.dialogs.data = {};
        });
      }
    },
    async fetchStreamersData(): Promise<void> {
      if (!this.operatorId) return;

      try {
        this.isLoading = true;

        const { content, totalElements } = await getStreamersList({
          size: this.tableOptions.itemsPerPage,
          page: this.tableOptions.page - 1,
          operatorId: this.operatorId,
          streamingType: EStreamingType.WHIP
        });

        this.streamersList = content;
        this.total = totalElements;
      } catch (error) {
        errorToastMessage(error);
      } finally {
        this.isLoading = false;
      }
    },
    async handlerOnStreamerBroadcastStatusChange(
      streamer: TStreamer
    ): Promise<void> {
      try {
        this.isLoading = true;

        const formData = new FormData();
        formData.append(
          'streamer',
          objectToBlob({
            operatorUserId: streamer.operatorUserId,
            nickname: streamer.nickname,
            type: streamer.type,
            language: streamer.language,
            accessCode: streamer.accessCode || null,
            streamingType: streamer.streamingType,
            active: !streamer.active
          })
        );

        await updateStreamer(streamer.id, formData);

        this.fetchStreamersData();
        this.$toast.success(
          `Streamer "${streamer.nickname}" broadcast status was successfully changed`
        );
        this.closeDialog('confirm');
      } catch (error) {
        errorToastMessage(error);
      } finally {
        this.isLoading = false;
      }
    },
    async handlerOnStartStream(streamer: TStreamer): Promise<void> {
      try {
        this.dialogs.loading = true;

        await startStreamerBroadcast(streamer.id);

        this.fetchStreamersData();
        this.$toast.success(
          `Stream for "${streamer.nickname}" was successfully started`
        );
        this.closeDialog('confirm');
      } catch (error) {
        errorToastMessage(error);
      } finally {
        this.dialogs.loading = false;
      }
    },
    async handleSubmitCreateEditStreamerDialog({
      isEdit,
      streamer
    }: {
      isEdit: boolean;
      streamer: TStreamer;
    }): Promise<void> {
      if (!isEdit) {
        this.showStreamerThumbnailsDialog(streamer);
      } else {
        await this.fetchStreamersData();
      }
    },
    async handleSubmitStreamerThumbnailsDialog({
      isEdit,
      streamer
    }: {
      isEdit: boolean;
      streamer: TStreamer;
    }): Promise<void> {
      if (!isEdit) {
        this.$nextTick(() => {
          this.showBroadcastSettingsDialog(streamer);
        });
      }

      await this.fetchStreamersData();
    }
  }
};
